var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkitoneLogoCc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1161 178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5a93a1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.52,54.75H59.45L99.35,106l39.09-51.24h15.77v84.74H136V87.1a89.62,89.62,0,0,1,.65-9,56.51,56.51,0,0,1-4.92,8.87L99.85,129.31H95.91L64,86.77A38,38,0,0,1,59,78.07c.33,3.45.5,6.24.5,9v52.39H43.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.45,54.75H246.5l48.62,84.74H273l-10.19-18.56h-53.7l-9.85,18.56H179.5Zm27.1,50.91L236.32,71.17l-18.88,34.49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.38,54.75H395c13,0,19,4.6,19,16.42V91c0,11.83-6.08,16.43-19,16.43H383.8l39.09,32H394.64l-34.16-32H341.76v32H322.38Zm19.38,14.62V93H386.1c6.08,0,8.87-1.15,8.87-6.74V76.1c0-5.58-2.79-6.73-8.87-6.73Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M454.09,54.75H474V90.06l47-35.31h28.58L493.34,94.66l63.07,44.83h-31.7L474,102.21v37.28H454.09Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M584.49,54.75H604.2v84.74H584.49Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M687,139.49h-19.7V69.86H628.33V54.75h97.72V69.86H687Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M769.41,54.75h62.41c15.93,0,21,4.1,21,20v44.67c0,15.93-5.09,20-21,20H769.41c-15.93,0-21-4.1-21-20V74.79C748.39,58.85,753.48,54.75,769.41,54.75Zm63.72,68.81V69.86h-65v53.7Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M894.22,54.75h13.47l59.62,49.93a73.62,73.62,0,0,1,9.69,9.19c-.5-7.06-.83-12-.83-14.61V54.75h17.74v84.74H980.44L918.2,87.1a70.21,70.21,0,0,1-7.06-6.89c.66,6.56.82,11,.82,13.46v45.82H894.22Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1037.1,54.75h86.72V69.2h-67V88.09h39.09v14.45h-39.09v21h67.83v15.93H1037.1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkitoneLogoCc);
export default __webpack_public_path__ + "static/media/markitone_logo_cc.9a3f93dc125f47597a24f6bf9e422a57.svg";
export { ForwardRef as ReactComponent };